import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faImage } from '@fortawesome/pro-light-svg-icons';
import { Button } from '@shared/components/ui/button';
import { Label } from '@shared/components/ui/label';
import { Alert, AlertDescription } from '@shared/components/ui/shadcn/alert';
import { useTranslation } from 'react-i18next';

interface PlanProps {
  stripePortalUrl?: string;
  isLoadingStripe?: boolean;
}

export const Plan = ({ stripePortalUrl, isLoadingStripe }: PlanProps) => {
  const { t } = useTranslation('suscriptionModule');
  const handleManageClick = () => {
    if (stripePortalUrl) {
      window.open(stripePortalUrl, '_blank');
    }
  };
  return (
    <div className="space-y-4 mb-6 pb-8 gap-4 grid grid-cols-1 md:grid-cols-5 pt-4 border-b border-card-border">
      <div className="col-span-1 md:col-span-2">
        <Label className="text-lg font-semibold">{t('main.planTitle')}</Label>
      </div>
      <div className="col-span-1 md:col-span-3 !mt-0">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-4 mb-4">
          {/* Icono + Info */}
          <div className="flex flex-row items-center gap-3 flex-1 min-w-0">
            <div className="w-[56px] h-[56px] rounded-full flex items-center justify-center bg-hover-press light:bg-card-border mb-3 sm:mb-0">
              <FontAwesomeIcon icon={faImage} className="w-3 h-3" />
            </div>
            <div className="flex flex-col flex-1 min-w-0">
              <span className="font-semibold text-lg">{t('main.planName')}</span>
              <span
                className="text-sm text-complementary-text"
                dangerouslySetInnerHTML={{ __html: t('main.nextBilling') }}
              />
            </div>
          </div>
          {/* Botón */}
          <Button
            variant="primary"
            size="lg"
            className="shrink-0 w-full md:w-auto"
            data-testid="manage-suscription-button"
            onClick={handleManageClick}
            disabled={!stripePortalUrl || isLoadingStripe}
            loading={isLoadingStripe}
          >
            {t('main.manageButton')}
          </Button>
        </div>
        <Alert variant="default" className="mt-2">
          <div className="flex items-center gap-4">
            <FontAwesomeIcon icon={faInfoCircle} className="w-4 h-4 flex-shrink-0" />
            <AlertDescription className="text-base">{t('main.stripeInfo')}</AlertDescription>
          </div>
        </Alert>
      </div>
    </div>
  );
};
